import { useParams } from 'react-router-dom'
import { styled } from 'styled-components'
import { SectionLoadingState } from '../../../../components'
import { useAlgorithmRunDetails } from '../../../../hooks'
import useWorkspaceDetails from '../../../../hooks/useWorkspaceDetails'
import {
  FlowCytometryNodeResult,
  FlowCytometryReviewAnalysisRunResult,
  ReviewAnalysisOtherIssue,
} from '../../../../store/reducers/workspaceReducer'
import { SmartFunctionListPanelLayout } from '../../components/SmartFunctionListPanelLayout'
import { useMemo } from 'react'

const SectionLoadingStateContainer = styled.div`
  display: flex;
  height: calc(100vh - 224px);
`

const MassageListContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: var(--color-text);
`

const MessageContainer = styled.div`
  padding: 8px;
`

interface ExtendedReviewAnalysisOtherIssue extends ReviewAnalysisOtherIssue {
  key: string
}

const FlowCytometryReviewAnalysisReportPanel = () => {
  const { workspaceId, algorithmRunId } = useParams()

  const { selectedWorkspace } = useWorkspaceDetails({
    workspaceId,
    preventFetch: true,
  })

  const { loading, selectedAlgorithmRun } = useAlgorithmRunDetails({
    workspaceId,
    algorithmRunId,
    preventFetch: true,
  })

  console.log('Temporary line report', selectedWorkspace, selectedAlgorithmRun)

  const nodeResults = useMemo(
    () =>
      selectedAlgorithmRun?.nodeResults
        ? ((selectedAlgorithmRun?.nodeResults as FlowCytometryNodeResult)
            ?.REVIEW_ANALYSIS as FlowCytometryReviewAnalysisRunResult)
        : undefined,
    [selectedAlgorithmRun],
  )

  const formattedData: ExtendedReviewAnalysisOtherIssue[] = useMemo(
    () =>
      nodeResults && nodeResults.otherIssues
        ? nodeResults.otherIssues.map(
            (issue: ReviewAnalysisOtherIssue, dataIndex) =>
              ({
                ...issue,
                key: `${dataIndex}`,
              }) as ExtendedReviewAnalysisOtherIssue,
          )
        : [],
    [nodeResults],
  )

  // const formattedData: ExtendedReviewAnalysisOtherIssue[] = [
  //   {
  //     key: '1',
  //     message: 'Issue message example',
  //   },
  //   {
  //     key: '2',
  //     message: 'Issue message example 2',
  //   },
  //   {
  //     key: '3',
  //     message: 'Issue message example 3',
  //   },
  // ]

  return loading ? (
    <SectionLoadingStateContainer>
      <SectionLoadingState />
    </SectionLoadingStateContainer>
  ) : (
    <SmartFunctionListPanelLayout>
      <MassageListContainer>
        {formattedData.map((item) => (
          <MessageContainer key={item.key}>{item.message}</MessageContainer>
        ))}
      </MassageListContainer>
    </SmartFunctionListPanelLayout>
  )
}

export default FlowCytometryReviewAnalysisReportPanel
